/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/vi_VN';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Truy cập trình chỉnh sửa HTML đẹp"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Trình Kiểm Tra Khả Năng Truy Cập"
  },
  "action_to_take_b626a99a": {
    "message": "Thao tác sẽ thực hiện:"
  },
  "add_8523c19b": {
    "message": "Thêm"
  },
  "add_a_caption_2a915239": {
    "message": "Thêm phụ đề"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Thêm văn bản thay thế cho hình ảnh"
  },
  "add_another_f4e50d57": {
    "message": "Thêm khác"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Thêm Phụ Đề"
  },
  "add_image_60b2de07": {
    "message": "Thêm Hình Ảnh"
  },
  "add_one_9e34a6f8": {
    "message": "Thêm ngay!"
  },
  "additional_considerations_f3801683": {
    "message": "Cân nhắc bổ sung"
  },
  "address_applied_64269b0b": {
    "message": "Đã áp dụng địa chỉ"
  },
  "address_removed_fcb496e0": {
    "message": "Đã gỡ địa chỉ"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Liên kết liền kề có cùng URL phải là liên kết đơn."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Căn Chỉnh"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Căn Chỉnh Và Danh Sách"
  },
  "all_4321c3a1": {
    "message": "Tất Cả"
  },
  "all_apps_a50dea49": {
    "message": "Tất Cả Ứng Dụng"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Cho phép tải phương tiện"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Cho phép tải bảng điểm"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "Thứ Tự Bảng Chữ Cái"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Văn bản thuộc tính thay thế không được chứa quá 120 ký tự."
  },
  "alt_text_611fb322": {
    "message": "Văn Bản Thay Thế"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Sản phẩm phụ)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Đã xảy ra lỗi khi đọc tập tin"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Đã xảy ra lỗi khi thực hiện yêu cầu mạng"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Đã xảy ra lỗi khi tải lên nội dung phương tiện."
  },
  "and_7fcc2911": {
    "message": "Và"
  },
  "angle_c5b4ec50": {
    "message": "Góc"
  },
  "announcement_fb4cb645": {
    "message": "Thông Báo"
  },
  "announcement_list_da155734": {
    "message": "Danh Sách Thông Báo"
  },
  "announcements_a4b8ed4a": {
    "message": "Thông Báo Chung"
  },
  "apply_781a2546": {
    "message": "Áp Dụng"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Áp dụng thay đổi cho tất cả phiên bản của Biểu Tượng Trình Tạo Biểu Tượng này trong Khóa Học"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Tiếp Cận Giới Hạn"
  },
  "approximately_e7965800": {
    "message": "Xấp Xỉ"
  },
  "apps_54d24a47": {
    "message": "Ứng Dụng"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Bạn có chắc là muốn hủy? Những thay đổi bạn đã thực hiện có thể không được lưu."
  },
  "arrows_464a3e54": {
    "message": "Các phím mũi tên"
  },
  "art_icon_8e1daad": {
    "message": "Biểu Tượng Nghệ Thuật"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Tỷ lệ khung hình sẽ được giữ nguyên"
  },
  "assignment_976578a8": {
    "message": "Bài Tập"
  },
  "assignments_1e02582c": {
    "message": "Bài Tập"
  },
  "asterisk_82255584": {
    "message": "Dấu Hoa Thị"
  },
  "attributes_963ba262": {
    "message": "Thuộc Tính"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Chức năng ghi âm và quay video không được hỗ trợ; vui lòng sử dụng trình duyệt khác."
  },
  "audio_options_feb58e2c": {
    "message": "Các Tùy Chọn Âm Thanh"
  },
  "audio_options_tray_33a90711": {
    "message": "Khay Tùy Chọn Âm Thanh"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Trình phát âm thanh cho { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Nội dung tự động lưu tồn tại. Bạn có muốn tải nội dung tự động lưu để thay thế không?"
  },
  "available_folders_694d0436": {
    "message": "Thư Mục Khả Dụng"
  },
  "background_1bc88842": {
    "message": "Nền"
  },
  "backslash_b2d5442d": {
    "message": "Dấu Chéo Ngược"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Cơ Bản"
  },
  "because_501841b": {
    "message": "Bởi Vì"
  },
  "below_81d4dceb": {
    "message": "Bên Dưới"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Vòng Tròn Lớn"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Hệ Số Nhị Thức"
  },
  "black_4cb01371": {
    "message": "Đen"
  },
  "blue_daf8fea9": {
    "message": "Xanh Dương"
  },
  "bold_applied_42d547b7": {
    "message": "Đã áp dụng in đậm"
  },
  "bold_removed_da474a5c": {
    "message": "Đã gỡ in đậm"
  },
  "border_5b08b06d": {
    "message": "Viền"
  },
  "bottom_15a2a9be": {
    "message": "Đáy"
  },
  "bottom_third_5f5fec1d": {
    "message": "Một Phần Ba Dưới"
  },
  "bowtie_5f9629e4": {
    "message": "Nơ"
  },
  "brick_f2656265": {
    "message": "Gạch"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Hủy"
  },
  "cap_product_3a5265a6": {
    "message": "Sản Phẩm Nắp"
  },
  "caption_manager_aae0906f": {
    "message": "Trình Quản Lý Chú Thích"
  },
  "center_align_e68d9997": {
    "message": "Căn Chỉnh Trung Tâm"
  },
  "centered_dot_64d5e378": {
    "message": "Dấu Chấm Căn Giữa"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Dấu Chấm Ngang Căn Giữa"
  },
  "change_alt_text_92654906": {
    "message": "Thay đổi văn bản thay thế"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Thay đổi thẻ đầu đề cho đoạn"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Chỉ thay đổi cấp độ của đầu đề này"
  },
  "change_text_color_1aecb912": {
    "message": "Thay đổi màu văn bản"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Thay đổi sẽ được áp dụng sau khi bạn lưu trang này."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Những thay đổi bạn đã thực hiện có thể không được lưu."
  },
  "characters_9d897d1c": {
    "message": "Số ký tự"
  },
  "characters_no_spaces_485e5367": {
    "message": "Số ký tự (không có dấu cách)"
  },
  "check_accessibility_3c78211c": {
    "message": "Kiểm Tra Khả Năng Tiếp Cận"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Kiểm tra các vấn đề khả năng tiếp cận"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Chọn tập tin phụ đề"
  },
  "choose_usage_rights_33683854": {
    "message": "Chọn quyền sử dụng..."
  },
  "circle_484abe63": {
    "message": "Tròn"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "danh sách không theo thứ tự tròn"
  },
  "clear_2084585f": {
    "message": "Xóa bỏ"
  },
  "clear_image_3213fe62": {
    "message": "Xóa hình ảnh"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Nhấp vào hoặc nhấn phím Shift - nhấp vào để mở trình chỉnh sửa html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Nhấp để nhúng { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Nhấp vào để ẩn phần xem trước."
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Nhấp vào để chèn liên kết vào trình chỉnh sửa."
  },
  "click_to_show_preview_faa27051": {
    "message": "Nhấp vào để hiển thị phần xem trước."
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Đóng menu hoặc hộp thoại. Đồng thời đưa bạn trở lại khu vực trình chỉnh sửa."
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Đóng Trình Kiểm Tra Khả Năng Truy Cập"
  },
  "close_d634289d": {
    "message": "Đóng"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Đóng Phương Thức Phím Tắt"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Tập tin có phụ đề phải dưới { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Phụ Đề"
  },
  "clubs_suit_c1ffedff": {
    "message": "Nhép (Hoa)"
  },
  "collab_575ac7bc": {
    "message": "Cộng Tác"
  },
  "collaborations_5c56c15f": {
    "message": "Cộng Tác"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Thu gọn để ẩn { types }"
  },
  "color_a363e1b0": {
    "message": "Màu"
  },
  "color_contrast_4c418add": {
    "message": "Tương Phản Màu"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Tỷ Lệ Tương Phản Màu"
  },
  "color_picker_6b359edf": {
    "message": "Trình Chọn Màu"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Trình Chọn Màu (đã chọn { colorName })"
  },
  "color_popup_af39810f": {
    "message": "Cửa sổ bật lên màu"
  },
  "column_e1ae5c64": {
    "message": "Cột"
  },
  "column_group_1c062368": {
    "message": "Nhóm cột"
  },
  "complex_numbers_a543d004": {
    "message": "Số Phức"
  },
  "computer_1d7dfa6f": {
    "message": "Máy Tính"
  },
  "congruent_5a244acd": {
    "message": "Đồng Dư"
  },
  "contains_311f37b7": {
    "message": "Chứa"
  },
  "content_1440204b": {
    "message": "Nội Dung"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Nội dung trong công cụ chỉnh sửa sẽ được thay đổi. Nhấn Hủy để giữ lại nội dung ban đầu."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Nội dung vẫn đang được tải lên, nếu bạn tiếp tục, nội dung sẽ không được nhúng đầy đủ."
  },
  "content_subtype_5ce35e88": {
    "message": "Loại Phụ Nội Dung"
  },
  "content_type_2cf90d95": {
    "message": "Loại Nội Dung"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Tiếp tục đến nội dung Youtube"
  },
  "coproduct_e7838082": {
    "message": "Sản Phẩm Phụ"
  },
  "copyright_holder_66ee111": {
    "message": "Bên Giữ Bản Quyền:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Không thể chèn nội dung: Các mục \"{ itemType }\" hiện không được hỗ trợ trong Canvas."
  },
  "count_40eced3b": {
    "message": "Số Lượng"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 từ}\n    one {1 từ}\n  other {# từ}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# mục đã được tải}\n  other {# mục đã được tải}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Tài Liệu Khóa Học"
  },
  "course_files_62deb8f8": {
    "message": "Các Tập Tin Khóa Học"
  },
  "course_files_a31f97fc": {
    "message": "Tập tin khóa học"
  },
  "course_images_f8511d04": {
    "message": "Hình Ảnh Khóa Học"
  },
  "course_link_b369426": {
    "message": "Liên Kết Khóa Học"
  },
  "course_links_b56959b9": {
    "message": "Liên Kết Khóa Học"
  },
  "course_media_ec759ad": {
    "message": "Nội Dung Phương Tiện Khóa Học"
  },
  "course_navigation_dd035109": {
    "message": "Điều Hướng Khóa Học"
  },
  "create_icon_110d6463": {
    "message": "Tạo Biểu Tượng"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Tạo Biểu Tượng Trình Tạo Biểu Tượng"
  },
  "creative_commons_license_725584ae": {
    "message": "Giấy Phép Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Cắt gọt hình ảnh"
  },
  "crop_image_807ebb08": {
    "message": "Cắt Gọt Hình Ảnh"
  },
  "cup_product_14174434": {
    "message": "Sản Phẩm Cốc"
  },
  "current_image_f16c249c": {
    "message": "Hình Ảnh Hiện Tại"
  },
  "current_link_945a47ee": {
    "message": "Liên Kết Hiện Tại"
  },
  "current_volume_level_c55ab825": {
    "message": "Mức Âm Lượng Hiện Tại"
  },
  "custom_6979cd81": {
    "message": "Tùy Chỉnh"
  },
  "cyan_c1d5f68a": {
    "message": "Xanh Lá Mạ"
  },
  "dagger_57e0f4e5": {
    "message": "Dấu Chữ Thập"
  },
  "date_added_ed5ad465": {
    "message": "Ngày Thêm"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Biểu Tượng Trang Trí"
  },
  "decorative_image_fde98579": {
    "message": "Hình ảnh trang trí"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Trang trí { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Giảm Thụt Lề"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Giảm Vùng Nội Dung Phong Phú"
  },
  "deep_purple_bb3e2907": {
    "message": "Tía Đen"
  },
  "default_9db103d": {
    "message": "Mặc Định"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "danh sách không theo thứ tự đánh dấu đầu dòng mặc định"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "danh sách theo thứ tự số mặc định"
  },
  "definite_integral_fe7ffed1": {
    "message": "Tích Phân Xác Định"
  },
  "degree_symbol_4a823d5f": {
    "message": "Biểu Tượng Độ"
  },
  "delimiters_4db4840d": {
    "message": "Dấu Phân Cách"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Mô tả biểu tượng)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Mô tả { TYPE })"
  },
  "description_436c48d7": {
    "message": "Mô Tả"
  },
  "details_98a31b68": {
    "message": "Chi Tiết"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Dấu Chấm Chéo"
  },
  "diamond_b8dfe7ae": {
    "message": "Hình Thoi"
  },
  "diamonds_suit_526abaaf": {
    "message": "Rô (Hoa)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Loại Kích Thước"
  },
  "directionality_26ae9e08": {
    "message": "Định Hướng"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Chỉnh Sửa LaTeX Trực Tiếp"
  },
  "disable_preview_222bdf72": {
    "message": "Tắt Xem Trước"
  },
  "discussion_6719c51d": {
    "message": "Thảo Luận"
  },
  "discussions_a5f96392": {
    "message": "Thảo Luận"
  },
  "discussions_index_6c36ced": {
    "message": "Chỉ Mục Thảo Luận"
  },
  "disjoint_union_e74351a8": {
    "message": "Liên Hợp Rời Rạc"
  },
  "display_options_315aba85": {
    "message": "Tùy Chọn Hiển Thị"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Hiển Thị Liên Kết Văn Bản (mở trong tác vụ mới)"
  },
  "div_applied_49ad83fc": {
    "message": "Đã áp dụng div"
  },
  "div_removed_d13f8e17": {
    "message": "Đã gỡ div"
  },
  "division_sign_72190870": {
    "message": "Dấu Chia"
  },
  "document_678cd7bf": {
    "message": "Tài Liệu"
  },
  "documents_81393201": {
    "message": "Tài Liệu"
  },
  "done_54e3d4b6": {
    "message": "Đã xong"
  },
  "double_dagger_faf78681": {
    "message": "Dấu Chữ Thập Kép"
  },
  "down_5831a426": {
    "message": "Xuống"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Mũi Tên Chéo Xuống Và Bên Trái"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Mũi Tên Chéo Xuống Và Bên Phải"
  },
  "download_filename_2baae924": {
    "message": "Tải xuống { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Mũi Tên Hướng Xuống"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Tam Giác Chỉ Hướng Xuống"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Kéo tập tin vào đây"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Kéo và thả hoặc nhấp vào để duyệt xem máy tính của bạn"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Tay cầm kéo. Sử dụng mũi tên lên và xuống để thay đổi kích cỡ"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Hạn: Nhiều Ngày"
  },
  "due_when_7eed10c6": {
    "message": "Hạn: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Chỉnh sửa văn bản thay thế phiên bản biểu tượng này"
  },
  "edit_c5fbea07": {
    "message": "Chỉnh Sửa"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Chỉnh Sửa Liên Kết Khóa Học"
  },
  "edit_equation_f5279959": {
    "message": "Chỉnh Sửa Phương Trình"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Chỉnh Sửa Biểu Tượng của Trình Tạo Biểu Tượng Hiện Có"
  },
  "edit_icon_2c6b0e91": {
    "message": "Biểu Tượng Chỉnh Sửa"
  },
  "edit_link_7f53bebb": {
    "message": "Chỉnh Sửa Liên Kết"
  },
  "editor_status_bar_653f44ee": {
    "message": "Thanh Trạng Thái Trình Chỉnh Sửa"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Yếu tố bắt đầu bằng { start }"
  },
  "embed_828fac4a": {
    "message": "Nhúng"
  },
  "embed_code_314f1bd5": {
    "message": "Mã Nhúng"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Nhúng nội dung từ Công Cụ Ngoài"
  },
  "embed_image_1080badc": {
    "message": "Nhúng Hình Ảnh"
  },
  "embed_video_a97a64af": {
    "message": "Nhúng Video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "nội dung nhúng"
  },
  "empty_set_91a92df4": {
    "message": "Tập Rỗng"
  },
  "encircled_dot_8f5e51c": {
    "message": "Dấu Chấm Bao Quanh"
  },
  "encircled_minus_72745096": {
    "message": "Dấu Trừ Bao Quanh"
  },
  "encircled_plus_36d8d104": {
    "message": "Dấu Cộng Bao Quanh"
  },
  "encircled_times_5700096d": {
    "message": "Dấu Nhân Bao Quanh"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Biểu Tượng Kỹ Thuật"
  },
  "english_icon_25bfe845": {
    "message": "Biểu Tượng Tiếng Anh"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Nhập tiêu đề phương tiện"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Nhập ít nhất 3 ký tự để tìm kiếm"
  },
  "enter_replacement_text_17631bbc": {
    "message": "nhập văn bản thay thế"
  },
  "enter_search_text_26cb4459": {
    "message": "nhập văn bản tìm kiếm"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Biến)"
  },
  "equals_sign_c51bdc58": {
    "message": "Dấu Bằng"
  },
  "equation_1c5ac93c": {
    "message": "Phương Trình"
  },
  "equation_editor_39fbc3f1": {
    "message": "Trình Chỉnh Sửa Phương Trình"
  },
  "equilibrium_6ff3040b": {
    "message": "Cân Bằng"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Tập Hợp Tương Đương"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Tương Đương (Đồng Nhất Thức)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Tồn Tại"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Thoát Toàn Màn Hình"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Mở rộng nội dung xem trước theo Mặc Định"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Mở rộng để xem { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Liên Kết Bên Ngoài"
  },
  "external_tool_frame_70b32473": {
    "message": "Khung công cụ ngoài"
  },
  "external_tools_6e77821": {
    "message": "Công Cụ Ngoài"
  },
  "extra_large_b6cdf1ff": {
    "message": "Cực Lớn"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Rất Lớn ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Cực Nhỏ"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Biểu Tượng Ngoại Khóa"
  },
  "f_function_fe422d65": {
    "message": "F (hàm số)"
  },
  "fail_544e5dde": {
    "message": "KHÔNG ĐẠT"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Lấy nội dung tệp không thành công"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Không thể truy xuất nội dung từ công cụ ngoài"
  },
  "file_name_8fd421ff": {
    "message": "Tên tập tin"
  },
  "file_preview_21667a6e": {
    "message": "Xem trước tập tin"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Chế độ xem trước tập tin cho { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Đã vượt quá hạn ngạch bộ nhớ tập tin"
  },
  "file_url_c12b64be": {
    "message": "URL Tập Tin"
  },
  "filename_file_icon_602eb5de": {
    "message": "Biểu tượng tập tin { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Xem trước hình ảnh { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Xem trước văn bản { filename }"
  },
  "files_c300e900": {
    "message": "Các Tập Tin"
  },
  "files_index_af7c662b": {
    "message": "Chỉ Mục Tập Tin"
  },
  "find_8d605019": {
    "message": "Tìm"
  },
  "find_and_replace_6e345933": {
    "message": "Tìm Kiếm và Thay Thế"
  },
  "finish_bc343002": {
    "message": "Hoàn Thành"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Sửa hệ phân cấp đầu đề"
  },
  "flat_music_76d5a5c3": {
    "message": "Cao Độ Thấp (Âm Nhac)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Thanh công cụ tùy chọn yếu tố tập trung"
  },
  "folder_tree_fbab0726": {
    "message": "Cây thư mục"
  },
  "for_all_b919f972": {
    "message": "Cho Tất Cả"
  },
  "format_4247a9c5": {
    "message": "Định Dạng"
  },
  "format_as_a_list_142210c3": {
    "message": "Định dạng dưới dạng danh sách"
  },
  "formatting_5b143aa8": {
    "message": "Đang định dạng"
  },
  "forward_slash_3f90f35e": {
    "message": "Dấu Gạch Chéo"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Tìm thấy nội dung tự động lưu"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Tìm thấy { count, plural,\n     =0 {# kết quả}\n    one {# kết quả}\n  other {# kết quả}\n}"
  },
  "fraction_41bac7af": {
    "message": "Phân Số"
  },
  "fullscreen_873bf53f": {
    "message": "Toàn Màn Hình"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Đang tạo nội dung xem trước..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Hình ảnh dưới định dạng GIF/PNG lớn hơn { size } KB hiện không được hỗ trợ."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Đi đến thanh menu của trình chỉnh sửa"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Đi đến thanh công cụ của trình chỉnh sửa"
  },
  "grades_a61eba0a": {
    "message": "Điểm"
  },
  "graphics_text_bc9568bc": {
    "message": "Văn bản đồ họa"
  },
  "greater_than_e98af662": {
    "message": "Lớn Hơn"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Lớn Hơn Hoặc Bằng"
  },
  "greek_65c5b3f7": {
    "message": "Hy Lạp"
  },
  "green_15af4778": {
    "message": "Xanh Lục"
  },
  "grey_a55dceff": {
    "message": "Xám"
  },
  "group_documents_8bfd6ae6": {
    "message": "Tài Liệu Nhóm"
  },
  "group_files_4324f3df": {
    "message": "Các Tập Tin Nhóm"
  },
  "group_files_82e5dcdb": {
    "message": "Tập tin nhóm"
  },
  "group_images_98e0ac17": {
    "message": "Hình Ảnh Nhóm"
  },
  "group_isomorphism_45b1458c": {
    "message": "Đẳng Cấu Nhóm"
  },
  "group_link_63e626b3": {
    "message": "Liên Kết Nhóm"
  },
  "group_links_9493129e": {
    "message": "Liên Kết Nhóm"
  },
  "group_media_2f3d128a": {
    "message": "Nội Dung Phương Tiện Nhóm"
  },
  "group_navigation_99f191a": {
    "message": "Điều Hướng Nhóm"
  },
  "h_bar_bb94deae": {
    "message": "H Bar"
  },
  "hat_ea321e35": {
    "message": "Mũ"
  },
  "header_column_f27433cb": {
    "message": "Cột đầu đề"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Hàng và cột đầu đề"
  },
  "header_row_f33eb169": {
    "message": "Hàng đầu đề"
  },
  "heading_2_5b84eed2": {
    "message": "Đầu Đề 2"
  },
  "heading_3_2c83de44": {
    "message": "Đầu Đề 3"
  },
  "heading_4_b2e74be7": {
    "message": "Đầu Đề 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Đã áp dụng tiêu đề { h }"
  },
  "heading_h_removed_745f24a6": {
    "message": "Đã gỡ tiêu đề { h }"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Không được bỏ qua cấp đầu đề."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Đầu đề bắt đầu bằng { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Đầu đề không được chứa quá 120 ký tự."
  },
  "health_icon_8d292eb5": {
    "message": "Biểu Tượng Sức Khỏe"
  },
  "hearts_suit_e50e04ca": {
    "message": "Cơ (Hoa)"
  },
  "height_69b03e15": {
    "message": "Chiều Cao"
  },
  "hexagon_d8468e0d": {
    "message": "Lục Giác"
  },
  "hide_description_bfb5502e": {
    "message": "Ẩn mô tả"
  },
  "hide_title_description_caf092ef": {
    "message": "Ẩn mô tả { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Đánh dấu một phần tử để kích hoạt thanh công cụ tùy chọn phần tử"
  },
  "home_351838cd": {
    "message": "Cơ Sở"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Làm thế nào để yêu cầu và chỉnh sửa chú thích?"
  },
  "html_code_editor_fd967a44": {
    "message": "trình chỉnh sửa mã html"
  },
  "html_editor_fb2ab713": {
    "message": "Trình Chỉnh Sửa HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Tôi đã xin được phép sử dụng tập tin này."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Tôi là bên giữ bản quyền"
  },
  "icon_215a1dc6": {
    "message": "Biểu tượng"
  },
  "icon_8168b2f8": {
    "message": "biểu tượng"
  },
  "icon_color_b86dd6d6": {
    "message": "Màu Biểu Tượng"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Biểu Tượng Trình Tạo Biểu Tượng"
  },
  "icon_options_7e32746e": {
    "message": "Tùy Chọn Biểu Tượng "
  },
  "icon_options_tray_2b407977": {
    "message": "Khay Tùy Chọn Biểu Tượng"
  },
  "icon_preview_1782a1d9": {
    "message": "Xem Trước Biểu Tượng"
  },
  "icon_shape_30b61e7": {
    "message": "Hình Dạng Biểu Tượng"
  },
  "icon_size_9353edea": {
    "message": "Cỡ Biểu Tượng"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Nếu để trống, phần liên kết sẽ hiển thị dưới dạng tên liên kết khóa học"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Nếu Quyền Sử Dụng được yêu cầu, tập tin sẽ không phát hành cho đến khi được bật trong trang Tập Tin."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Nếu bạn không chọn quyền sử dụng lúc này thì tập tin sẽ không được công bố sau khi tải lên."
  },
  "image_8ad06": {
    "message": "Hình Ảnh"
  },
  "image_c1c98202": {
    "message": "hình ảnh"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Không được sử dụng tên tập tin của hình ảnh làm thuộc tính thay thế mô tả nội dung hình ảnh."
  },
  "image_options_5412d02c": {
    "message": "Tùy Chọn Hình Ảnh"
  },
  "image_options_tray_90a46006": {
    "message": "Khay Tùy Chọn Hình Ảnh"
  },
  "image_to_crop_3a34487d": {
    "message": "Hình ảnh để cắt gọt"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Hình ảnh có tên tập tin { file }"
  },
  "images_7ce26570": {
    "message": "Hình Ảnh"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Hình ảnh phải chứa một thuộc tính thay thế mô tả nội dung hình ảnh đó."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Phần Ảo (của Số Phức)"
  },
  "in_element_of_19ca2f33": {
    "message": "Thuộc (Phần Tử Của)"
  },
  "increase_indent_6af90f7c": {
    "message": "Tăng Thụt Lề"
  },
  "increase_rich_content_area_340b775": {
    "message": "Tăng Vùng Nội Dung Phong Phú"
  },
  "indefinite_integral_6623307e": {
    "message": "Tích Phân Không Xác Định"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } / { max }"
  },
  "indigo_2035fc55": {
    "message": "Chàm"
  },
  "inference_fed5c960": {
    "message": "Kết Luận"
  },
  "infinity_7a10f206": {
    "message": "Vô Hạn"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Trường đầu vào cho alpha"
  },
  "input_field_for_blue_561e020a": {
    "message": "Trường đầu vào cho màu xanh dương"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Trường đầu vào cho màu xanh lá cây"
  },
  "input_field_for_red_86a84615": {
    "message": "Trường đầu vào cho màu đỏ"
  },
  "insert_593145ef": {
    "message": "Chèn"
  },
  "insert_link_6dc23cae": {
    "message": "Chèn Liên Kết"
  },
  "insert_math_equation_57c6e767": {
    "message": "Chèn Phương Trình Toán"
  },
  "integers_336344e1": {
    "message": "Số Nguyên"
  },
  "intersection_cd4590e4": {
    "message": "Giao Điểm"
  },
  "invalid_description_991e23bb": {
    "message": "Mô tả không hợp lệ"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Lối vào không hợp lệ."
  },
  "invalid_file_c11ba11": {
    "message": "Tập Tin Không Hợp Lệ"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Loại tập tin không hợp lệ"
  },
  "invalid_url_cbde79f": {
    "message": "URL không hợp lệ"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Vấn đề { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Đã áp dụng in nghiêng"
  },
  "italic_removed_17cbab6f": {
    "message": "Đã gỡ in nghiêng"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Biến)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Phím Tắt"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Bàn phím điều hướng đến liên kết bằng cách sử dụng phím Tab. Hai liên kết đối diện có chức năng chuyển hướng đến cùng điểm đích có thể gây khó hiểu cho người dùng bàn phím."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Biểu Tượng Nghệ Thuật Ngôn Ngữ"
  },
  "languages_icon_9d20539": {
    "message": "Biểu Tượng Ngôn Ngữ"
  },
  "large_9c5e80e7": {
    "message": "Lớn"
  },
  "large_text_e7ba08cd": {
    "message": "Văn bản khổ lớn"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Lớn ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Học Tập"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Tìm hiểu thêm về các liên kết liền kề"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Tìm hiểu thêm về độ tương phản màu sắc"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Tìm hiểu thêm về sắp xếp các tiêu đề trang"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Tìm hiểu thêm về cấu trúc đầu đề trang phù hợp"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Tìm hiểu thêm về các đầu đề bảng"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Tìm hiểu thêm về sử dụng văn bản thay thế cho hình ảnh"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Tìm hiểu thêm về sử dụng chú thích với bảng"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Tìm hiểu thêm về sử dụng tên tập tin làm văn bản thay thế"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Tìm hiểu thêm về sử dụng danh sách"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Tìm hiểu thêm về sử dụng thuộc tính phạm vi với bảng"
  },
  "leave_as_is_4facfe55": {
    "message": "Để nguyên"
  },
  "left_3ea9d375": {
    "message": "Trái"
  },
  "left_align_43d95491": {
    "message": "Căn Chỉnh Sang Trái"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Dấu Nhỏ Hơn"
  },
  "left_arrow_4fde1a64": {
    "message": "Mũi Tên Trái"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Mũi Tên Trái Có Móc"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Trần Trái"
  },
  "left_curly_brace_1726fb4": {
    "message": "Dấu Ngoặc Nhọn Trái"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Dấu Mũi Tên Có Móc Hướng Xuống Bên Trái"
  },
  "left_floor_29ac2274": {
    "message": "Sàn Trái"
  },
  "left_to_right_e9b4fd06": {
    "message": "Trái Sang Phải"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Dấu Mũi Tên Có Móc Hướng Lên Bên Trái"
  },
  "leftward_arrow_1e4765de": {
    "message": "Mũi Tên Chỉ Về Bên Trái"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Tam Giác Chỉ Về Bên Trái"
  },
  "less_than_a26c0641": {
    "message": "Nhỏ Hơn"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Nhỏ Hơn Hoặc Bằng"
  },
  "library_icon_ae1e54cf": {
    "message": "Biểu Tượng Thư Viện"
  },
  "light_blue_5374f600": {
    "message": "Xanh Dương Nhạt"
  },
  "link_7262adec": {
    "message": "Liên Kết"
  },
  "link_options_a16b758b": {
    "message": "Tùy Chọn Liên Kết"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "loại liên kết: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Liên kết có văn bản bắt đầu bằng { start }"
  },
  "links_14b70841": {
    "message": "Liên Kết"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Liên kết đến một trang bên ngoài."
  },
  "lists_cd1336fc": {
    "message": "Danh Sách"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Các danh sách phải được định dạng dưới dạng danh sách."
  },
  "load_more_35d33c7": {
    "message": "Tải Thêm"
  },
  "loading_25990131": {
    "message": "Đang tải..."
  },
  "loading_bde52856": {
    "message": "Đang tải"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "không tải được chú thích/phụ đề đã đóng."
  },
  "loading_external_tool_d839042c": {
    "message": "Đang Tải Công Cụ Bên Ngoài"
  },
  "loading_failed_b3524381": {
    "message": "Tải thất bại..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Tải thất bại."
  },
  "loading_folders_d8b5869e": {
    "message": "Đang tải thư mục"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Đang tải trình giữ chỗ cho { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Đang tải, vui lòng chờ"
  },
  "loading_preview_9f077aa1": {
    "message": "Đang tải bản xem trước"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Khóa tốc độ ở 1x"
  },
  "locked_762f138b": {
    "message": "Bị Khóa"
  },
  "logical_equivalence_76fca396": {
    "message": "Tương Đương Về Logic"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Tương Đương Về Logic (Ngắn)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Tương Đương Về Logic (Ngắn Và Dày)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Tương Đương Về Logic (Dày)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Dấu Chấm Ngang Thấp"
  },
  "magenta_4a65993c": {
    "message": "Hồng Sẫm"
  },
  "maps_to_e5ef7382": {
    "message": "Bản Đồ Tới"
  },
  "math_icon_ad4e9d03": {
    "message": "Biểu Tượng Toán"
  },
  "media_af190855": {
    "message": "Phương Tiện"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Tập tin phương tiện đang xử lý. Vui lòng thử lại sau."
  },
  "media_options_saved_560c4ec8": {
    "message": "Đã lưu các tùy chọn cho phương tiện."
  },
  "media_title_2112243b": {
    "message": "Tiêu Đề Phương Tiện"
  },
  "medium_5a8e9ead": {
    "message": "Trung bình"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Vừa ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Gộp liên kết"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Microphone Bị Tắt"
  },
  "middle_27dc1d5": {
    "message": "Giữa"
  },
  "minimize_file_preview_da911944": {
    "message": "Thu Nhỏ Bản Xem Trước Tệp"
  },
  "minimize_video_20aa554b": {
    "message": "Thu Nhỏ Video"
  },
  "minus_fd961e2e": {
    "message": "Trừ"
  },
  "minus_plus_3461f637": {
    "message": "Trừ/Cộng"
  },
  "misc_3b692ea7": {
    "message": "Hỗn hợp"
  },
  "miscellaneous_e9818229": {
    "message": "Tổng Hợp"
  },
  "module_90d9fd32": {
    "message": "Học Phần"
  },
  "modules_c4325335": {
    "message": "Học Phần"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Di chuyển hình ảnh để cắt { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Ảnh Nhiều Màu"
  },
  "multiplication_sign_15f95c22": {
    "message": "Dấu Nhân"
  },
  "music_icon_4db5c972": {
    "message": "Biểu Tượng Âm Nhạc"
  },
  "my_files_2f621040": {
    "message": "Tập tin của tôi"
  },
  "n_th_root_9991a6e4": {
    "message": "Căn Bậc N"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Tên"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Tự Nhiên (Âm Nhạc)"
  },
  "natural_numbers_3da07060": {
    "message": "Số Tự Nhiên"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Điều hướng qua menu hoặc thanh công cụ"
  },
  "navigation_ee9af92d": {
    "message": "Điều Hướng"
  },
  "nested_greater_than_d852e60d": {
    "message": "Lồng Vào Lớn Hơn"
  },
  "nested_less_than_27d17e58": {
    "message": "Lồng Vào Nhỏ Hơn"
  },
  "new_quiz_34aacba6": {
    "message": "Câu Hỏi Kiểm Tra Mới"
  },
  "next_40e12421": {
    "message": "Tiếp"
  },
  "next_findtext_9d69f0fe": {
    "message": "{ findText } Tiếp Theo"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Không phát hiện vấn đề khả năng tiếp cận."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Chưa tạo thông báo chung nào."
  },
  "no_announcements_found_20185afc": {
    "message": "Không tìm thấy thông báo chung nào."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Chưa tạo bài tập nào."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Không tìm thấy bài tập nào."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Không có thay đổi nào để lưu."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Chưa tạo cuộc thảo luận nào."
  },
  "no_discussions_found_9284063b": {
    "message": "Không tìm thấy cuộc thảo luận nào."
  },
  "no_e16d9132": {
    "message": "Không"
  },
  "no_file_chosen_9a880793": {
    "message": "Không có tập tin được chọn"
  },
  "no_headers_9bc7dc7f": {
    "message": "Không có đầu đề"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Chưa tạo học phần nào."
  },
  "no_modules_found_2df43a40": {
    "message": "Không tìm thấy học phần nào."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Chưa tạo trang nào."
  },
  "no_pages_found_6799350": {
    "message": "Không tìm thấy trang nào."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Không có nội dung xem trước khả dụng cho tập tin này."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Chưa tạo câu hỏi kiểm tra nào."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Không tìm thấy câu hỏi kiểm tra nào."
  },
  "no_results_940393cf": {
    "message": "Không có kết quả."
  },
  "no_results_found_58717065": {
    "message": "Không tìm thấy kết quả"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Không tìm thấy kết quả cho { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Không Có Video"
  },
  "none_3b5e34d2": {
    "message": "Không Có"
  },
  "none_selected_b93d56d2": {
    "message": "Chưa Chọn Gì"
  },
  "normal_text_7b03da48": {
    "message": "Văn bản khổ bình thường"
  },
  "not_equal_6e2980e6": {
    "message": "Không Bằng Nhau"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Không Thuộc (Không Phải Phần Tử Của)"
  },
  "not_negation_1418ebb8": {
    "message": "Không Phải (Phủ Định)"
  },
  "not_subset_dc2b5e84": {
    "message": "Không Phải Tập Con"
  },
  "not_subset_strict_23d282bf": {
    "message": "Không Phải Tập Con (Thực Sự)"
  },
  "not_superset_5556b913": {
    "message": "Không Phải Tập Lớn"
  },
  "not_superset_strict_24e06f36": {
    "message": "Không Phải Tập Lớn (Thực Sự)"
  },
  "nu_1c0f6848": {
    "message": "Nuy"
  },
  "octagon_e48be9f": {
    "message": "Bát Giác"
  },
  "olive_6a3e4d6b": {
    "message": "Ô liu"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Bạn phải thêm một trong các kiểu sau để lưu biểu tượng: Màu Biểu Tượng, Kích Thước Đường Viền, Văn Bản Biểu Tượng hoặc Hình Ảnh"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Một hoặc nhiều tập tin không dán thành công. Vui lòng thử tải lên hoặc kéo và thả các tập tin."
  },
  "open_circle_e9bd069": {
    "message": "Vòng Tròn Mở"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Mở hộp thoại phím tắt này"
  },
  "open_title_application_fd624fc5": {
    "message": "Mở ứng dụng { title }"
  },
  "operators_a2ef9a93": {
    "message": "Toán Tử"
  },
  "options_3ab0ea65": {
    "message": "Tùy Chọn"
  },
  "or_9b70ccaa": {
    "message": "Hoặc"
  },
  "orange_81386a62": {
    "message": "Cam"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Danh Sách Theo Thứ Tự và Không Theo Thứ Tự"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Các phím tắt trình chỉnh sửa khác có trong"
  },
  "outline_color_3ef2cea7": {
    "message": "Màu Viền"
  },
  "outline_size_a6059a21": {
    "message": "Kích Thước Viền"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } không phải giao thức hợp lệ."
  },
  "page_50c4823d": {
    "message": "Trang"
  },
  "pages_e5414c2c": {
    "message": "Trang"
  },
  "paragraph_5e5ad8eb": {
    "message": "Đoạn"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Đã áp dụng đoạn văn"
  },
  "paragraph_removed_d09320e": {
    "message": "Đã gỡ đoạn văn"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Đoạn bắt đầu bằng { start }"
  },
  "parallel_d55d6e38": {
    "message": "Song Song"
  },
  "partial_derivative_4a9159df": {
    "message": "Riêng (Đạo Hàm)"
  },
  "pass_1c19a2b3": {
    "message": "ĐẠT"
  },
  "paste_5963d1c1": {
    "message": "Dán"
  },
  "pause_12af3bb4": {
    "message": "Tạm Dừng"
  },
  "pentagon_17d82ea3": {
    "message": "Hình Ngũ Giác"
  },
  "people_b4ebb13c": {
    "message": "Mọi Người"
  },
  "percentage_34ab7c2c": {
    "message": "Phần Trăm"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Phần trăm phải là số"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Phần trăm ít nhất phải bằng { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Biểu Tượng Nghệ Thuật Biểu Diễn"
  },
  "perpendicular_7c48ede4": {
    "message": "Vuông Góc"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Biến)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Biểu Tượng Giáo Dục Thể Chất"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Biến)"
  },
  "pick_a_color_557abfb0": {
    "message": "Chọn một màu"
  },
  "pink_68ad45cb": {
    "message": "Hồng"
  },
  "pixels_52ece7d1": {
    "message": "Pixel"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Pixel ít nhất phải bằng { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Phát"
  },
  "play_media_comment_35257210": {
    "message": "Phát bình luận phương tiện."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Phát bình luận phương tiện bằng { name } từ { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Bố cục trình phát"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Vui lòng cho phép Canvas truy cập microphone và webcam của bạn."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Vui lòng chọn một tập tin"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Vui lòng nhập tên tập tin"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Vui lòng nhập URL video hợp lệ từ một nền tảng được hỗ trợ."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Vui lòng chọn tập tin có loại được hỗ trợ"
  },
  "plus_d43cd4ec": {
    "message": "Cộng"
  },
  "plus_minus_f8be2e83": {
    "message": "Cộng/Trừ"
  },
  "posted_when_a578f5ab": {
    "message": "Đã đăng: { when }"
  },
  "power_set_4f26f316": {
    "message": "Tập Lũy Thừa"
  },
  "precedes_196b9aef": {
    "message": "Đứng Trước"
  },
  "precedes_equal_20701e84": {
    "message": "Đứng Trước Bằng"
  },
  "preformatted_d0670862": {
    "message": "Đã định dạng trước"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Trước"
  },
  "preview_53003fd2": {
    "message": "Xem trước"
  },
  "preview_a3f8f854": {
    "message": "XEM TRƯỚC"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Xem trước trong lớp phủ"
  },
  "preview_inline_9787330": {
    "message": "Xem trước trong dòng"
  },
  "previous_bd2ac015": {
    "message": "Trước"
  },
  "previous_findtext_8dfbfd30": {
    "message": "{ findText } Trước"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Các màu đã chọn trước đây"
  },
  "prime_917ea60e": {
    "message": "Nguyên Tố"
  },
  "prime_numbers_13464f61": {
    "message": "Số Nguyên Tố"
  },
  "product_39cf144f": {
    "message": "Sản Phẩm"
  },
  "proportional_f02800cc": {
    "message": "Tỷ Lệ"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Giao thức phải là ftp, http, https, mailto, skype, tel hoặc có thể lược bỏ"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "đã công bố"
  },
  "published_when_302d8e23": {
    "message": "Đã Phát Hành: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Bí Ngô"
  },
  "purple_7678a9fc": {
    "message": "Tía"
  },
  "quaternions_877024e0": {
    "message": "Quatenion"
  },
  "quiz_e0dcce8f": {
    "message": "Kiểm Tra"
  },
  "quizzes_7e598f57": {
    "message": "Các Câu Hỏi Kiểm Tra"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Số Hữu Tỉ"
  },
  "real_numbers_7c99df94": {
    "message": "Số Thực"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Phần Thực (của Số Phức)"
  },
  "record_7c9448b": {
    "message": "Ghi"
  },
  "record_upload_media_5fdce166": {
    "message": "Ghi/Tải Lên Nội Dung Phương Tiện"
  },
  "recording_98da6bda": {
    "message": "Đang ghi"
  },
  "red_8258edf3": {
    "message": "Đỏ"
  },
  "relationships_6602af70": {
    "message": "Mối Quan Hệ"
  },
  "religion_icon_246e0be1": {
    "message": "Biểu Tượng Tôn Giáo"
  },
  "remove_f47dc62a": {
    "message": "Gỡ"
  },
  "remove_filename_3ea029f6": {
    "message": "Gỡ { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Gỡ kiểu đầu đề"
  },
  "remove_link_d1f2f4d0": {
    "message": "Gỡ Liên Kết"
  },
  "replace_all_d3d68b3": {
    "message": "Thay Tất Cả"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Thay thế tất cả { findText } bằng { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Thay Thế"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Thay thế { findText } bằng { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Thay bằng"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Đã thay thế { alertFindText } bằng { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Đã thay thế tất cả { alertFindText } bằng { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Cài lại"
  },
  "resize_ec83d538": {
    "message": "Đổi Cỡ"
  },
  "restore_auto_save_deccd84b": {
    "message": "Khôi phục tự động lưu?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Kết quả { index } / { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Cửa Quay Ngược (Không Cong)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Biến)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Trình Chỉnh Sửa Nội Dung Phong Phú"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Khu Vực Văn Bản Phong Phú. Nhấn { OSKey }+F8 để dùng các phím tắt của Trình Chỉnh Sửa Nội Dung Phong Phú."
  },
  "right_71ffdc4d": {
    "message": "Phải"
  },
  "right_align_39e7a32a": {
    "message": "Căn Chỉnh Sang Phải"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Dấu Lớn Hơn"
  },
  "right_arrow_35e0eddf": {
    "message": "Mũi Tên Phải"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Mũi Tên Phải Có Móc"
  },
  "right_ceiling_839dc744": {
    "message": "Trần Phải"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Dấu Ngoặc Nhọn Bên Phải"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Dấu Mũi Tên Có Móc Hướng Xuống Bên Phải"
  },
  "right_floor_5392d5cf": {
    "message": "Sàn Phải"
  },
  "right_to_left_9cfb092a": {
    "message": "Phải Sang Trái"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Dấu Mũi Tên Có Móc Hướng Lên Bên Phải"
  },
  "rightward_arrow_32932107": {
    "message": "Mũi Tên Chỉ Về Bên Phải"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Tam Giác Chỉ Về Bên Phải"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Xoay hình ảnh -90 độ"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Xoay hình ảnh 90 độ"
  },
  "rotation_9699c538": {
    "message": "Xoay"
  },
  "row_fc0944a7": {
    "message": "Hàng"
  },
  "row_group_979f5528": {
    "message": "Nhóm hàng"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Rất tiếc, không thể sử dụng bàn phím trong trình chỉnh sửa HTML đẹp. Truy cập trình chỉnh sửa HTML thô ở đây."
  },
  "save_11a80ec3": {
    "message": "Lưu"
  },
  "save_copy_ca63944e": {
    "message": "Lưu Bản Sao"
  },
  "save_media_cb9e786e": {
    "message": "Lưu Nội Dung Phương Tiện"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Biểu Tượng Trình Tạo Biểu Tượng Đã Lưu"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Trình đọc màn hình không thể xác định nội dụng được hiển thị trong hình ảnh mà không có văn bản thay thế và tên tập tin thường là chuỗi số và chữ cái vô nghĩa không mô tả ngữ cảnh hoặc ý nghĩa."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Trình đọc màn hình không thể xác định nội dụng được hiển thị trong hình ảnh mà không có văn bản thay thế, vốn có chức năng mô tả nội dung và ý nghĩa của hình ảnh. Văn bản thay thế phải đơn giản và súc tích."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Trình đọc màn hình không thể xác định nội dụng được hiển thị trong hình ảnh mà không có văn bản thay thế, vốn có chức năng mô tả nội dung và ý nghĩa của hình ảnh."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Trình đọc màn hình không thể diễn giải bảng không có cấu trúc hoàn chỉnh. Đầu đề bảng là thứ cung cấp phương hướng và phạm vi nội dung."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Trình đọc màn hình không thể diễn giải bảng không có cấu trúc hoàn chỉnh. Phụ đề bảng là thứ mô tả ngữ cảnh và thông tin nắm bắt chung về bảng."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Trình đọc màn hình không thể diễn giải bảng không có cấu trúc hoàn chỉnh. Đầu đề bảng là thứ cung cấp phương hướng và giới thiệu tổng quan về nội dung."
  },
  "script_l_42a7b254": {
    "message": "Tập Lệnh L"
  },
  "search_280d00bd": {
    "message": "Tìm Kiếm"
  },
  "select_audio_source_21043cd5": {
    "message": "Chọn nguồn âm thanh"
  },
  "select_crop_shape_d441feeb": {
    "message": "Chọn hình dạng cắt gọt"
  },
  "select_language_7c93a900": {
    "message": "Chọn Ngôn Ngữ"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Chọn nguồn video"
  },
  "selected_274ce24f": {
    "message": "Đã chọn"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Đã Chọn { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Lựa Chọn"
  },
  "set_header_scope_8c548f40": {
    "message": "Cài đặt phạm vi đầu đề"
  },
  "set_minus_b46e9b88": {
    "message": "Trừ Nhóm"
  },
  "set_table_header_cfab13a0": {
    "message": "Cài đặt đầu đề bảng"
  },
  "sharp_music_ab956814": {
    "message": "Cao Độ Hơn (Âm Nhạc)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Mũi Tên"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Nhấn Shift-O để mở trình chỉnh sửa html đẹp."
  },
  "shortcut_911d6255": {
    "message": "Lối Tắt"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Hiển thị tùy chọn hình ảnh"
  },
  "show_link_options_545338fd": {
    "message": "Hiển thị tùy chọn liên kết"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Hiển thị bản điểm cuộn"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Hiển Thị Bản Chép Lời Cuộn"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Người dùng không bị khiếm thị duyệt nhanh trang web, tìm các đầu đề cỡ lớn hoặc được in đậm. Người dùng trình đọc màn hình phụ thuộc vào đầu đề để nắm bắt ngữ cảnh. Đầu đề phải sử dụng cấu trúc hoàn chỉnh."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Người dùng không bị khiếm thị duyệt nhanh trang web, tìm các đầu đề cỡ lớn hoặc được in đậm. Người dùng trình đọc màn hình phụ thuộc vào đầu đề để nắm bắt ngữ cảnh. Đầu đề phải súc tích trong phạm vi cấu trúc hoàn chỉnh."
  },
  "sigma_5c35e553": {
    "message": "Xichma"
  },
  "sigma_variant_8155625": {
    "message": "Xichma (Biến)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Ảnh Đơn Màu"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Màu Hình Ảnh Đơn Màu"
  },
  "size_b30e1077": {
    "message": "Cỡ"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Kích cỡ tập tin phụ đề lớn hơn mức kích thước tập tin tối đa là { max } kb."
  },
  "small_b070434a": {
    "message": "Nhỏ"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Nhỏ ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Vòng Tròn Đặc"
  },
  "something_went_wrong_89195131": {
    "message": "Đã xảy ra vấn đề."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Đã xảy ra vấn đề truy cập webcam của bạn."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Đã xảy ra vấn đề và tôi không biết phải hiển thị gì cho bạn."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Đã xảy ra lỗi. Kiểm tra kết nối của bạn, tải lại trang và thử lại."
  },
  "something_went_wrong_d238c551": {
    "message": "Đã xảy ra vấn đề"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Đã xảy ra vấn đề khi chia sẻ màn hình của bạn."
  },
  "sort_by_e75f9e3e": {
    "message": "Sắp Xếp Theo"
  },
  "spades_suit_b37020c2": {
    "message": "Bích (Hoa)"
  },
  "square_511eb3b3": {
    "message": "Vuông"
  },
  "square_cap_9ec88646": {
    "message": "Nắp Vuông"
  },
  "square_cup_b0665113": {
    "message": "Cốc Vuông"
  },
  "square_root_e8bcbc60": {
    "message": "Căn Bậc Hai"
  },
  "square_root_symbol_d0898a53": {
    "message": "Biểu Tượng Căn Bậc Hai"
  },
  "square_subset_17be67cb": {
    "message": "Tập Con Vuông"
  },
  "square_subset_strict_7044e84f": {
    "message": "Tập Con Vuông (Thực Sự)"
  },
  "square_superset_3be8dae1": {
    "message": "Tập Lớn Vuông"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Tập Lớn Vuông (Thực Sự)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "danh sách không theo thứ tự vuông"
  },
  "star_8d156e09": {
    "message": "Sao"
  },
  "start_over_f7552aa9": {
    "message": "Bắt Đầu Lại Từ Đầu"
  },
  "start_recording_9a65141a": {
    "message": "Bắt Đầu Ghi"
  },
  "steel_blue_14296f08": {
    "message": "Xanh Thép"
  },
  "studio_media_options_ee504361": {
    "message": "Các Tùy Chọn Phương Tiện Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Khay Tùy Chọn Phương Tiện Studio"
  },
  "styles_2aa721ef": {
    "message": "Kiểu"
  },
  "submit_a3cc6859": {
    "message": "Nộp"
  },
  "submitting_b90fac62": {
    "message": "Đang nộp..."
  },
  "subscript_59744f96": {
    "message": "Thu Nhỏ Nằm Trên"
  },
  "subset_19c1a92f": {
    "message": "Tập Con"
  },
  "subset_strict_8d8948d6": {
    "message": "Tập Con (Thực Sự)"
  },
  "succeeds_9cc31be9": {
    "message": "Nối Tiếp"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Nối Tiếp Bằng"
  },
  "sum_b0842d31": {
    "message": "Tổng"
  },
  "superscript_8cb349a2": {
    "message": "Thu Nhỏ Nằm Dưới"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Chỉ Số Trên và Chỉ Số Dưới"
  },
  "superset_c4db8a7a": {
    "message": "Tập Lớn"
  },
  "superset_strict_c77dd6d2": {
    "message": "Tập Lớn (Thực Sự)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Loại tập tin không được hỗ trợ: SRT hoặc WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Chuyển sang Trình Chỉnh Sửa HTML đẹp"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Chuyển sang Trình Chỉnh Sửa HTML thô"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Chuyển sang trình chỉnh sửa html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Chuyển sang trình chỉnh sửa văn bản phong phú"
  },
  "syllabus_f191f65b": {
    "message": "Chương Trình Học"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Đã Cho Phép Âm Thanh Hệ Thống"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Đã Tắt Âm Thanh Hệ Thống"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Mũi Tên"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Đầu đề bảng bắt đầu bằng { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Bảng bắt đầu bằng { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Đầu đề bảng phải xác định phạm vi."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Bảng phải có phụ đề mô tả nội dung của bảng đó."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Bảng phải có ít nhất một đầu đề."
  },
  "tau_880974b7": {
    "message": "Tô"
  },
  "teal_f729a294": {
    "message": "Xanh Mòng Két"
  },
  "text_7f4593da": {
    "message": "Văn Bản"
  },
  "text_background_color_16e61c3f": {
    "message": "Màu Nền Văn Bản"
  },
  "text_color_acf75eb6": {
    "message": "Màu Văn Bản"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Văn bản khó đọc, không đủ độ tương phản giữa văn bản và nền, đặc biệt là đối với những người có thị lực kém."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Văn bản có cỡ chữ lớn hơn 18 pt (hoặc in đậm 14 pt) phải hiển thị tỷ lệ tương phản tối thiểu là 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Văn Bản (tùy chọn)"
  },
  "text_position_8df8c162": {
    "message": "Vị Trí Văn Bản"
  },
  "text_size_887c2f6": {
    "message": "Cỡ Văn Bản"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Văn bản có cỡ nhỏ hơn 18 pt (hoặc in đậm 14 pt) phải hiển thị tỷ lệ tương phản tối thiểu là 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Bản xem trước tài liệu hiện đang được xử lý. Vui lòng thử lại sau."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Đầu đề đầu tiên trên một trang phải là H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Chiều cao của Vùng Nội Dung Phong Phú đã giảm."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Chiều cao của Vùng Nội Dung Phong Phú đã tăng."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Tài liệu này thuộc phạm vi công cộng"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Tài liệu này được cấp phép theo Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Tài liệu này thuộc trường hợp ngoại lệ - ví dụ như sử dụng công bằng, quyền trích dẫn hoặc trường hợp khác theo luật bản quyền hiện hành"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Không thể sử dụng bàn phím trong trình chỉnh sửa html đẹp. Nhấn Shift O để mở trình chỉnh sửa html thô."
  },
  "therefore_d860e024": {
    "message": "Vì Thế"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Biến)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Mũi Tên Chỉ Xuống Dày"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Mũi Tên Trái Dày"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Mũi Tên Chỉ Bên Trái Dày"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Mũi Tên Phải Dày"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Mũi Tên Chỉ Bên Phải Dày"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Mũi Tên Chỉ Lên Dày"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Không thể hiển thị tài liệu này trong Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Không thể hiển thị phương trình này trong Chế Độ Xem Cơ Bản."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Hình ảnh này hiện không khả dụng"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Video này có thể hiển thị quảng cáo YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Dù video của bạn sẽ có tiêu đề đúng trong trình duyệt, chúng tôi đã không thể tải lên cơ sở dữ liệu."
  },
  "thumbnail_e0de666f": {
    "message": "Hình Thu Nhỏ"
  },
  "timebar_a4d18443": {
    "message": "Thanh thời gian"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Không được để trống tiêu đề"
  },
  "title_ee03d132": {
    "message": "Tiêu Đề"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Sẽ Được Đăng: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Việc Cần Làm: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Chuyển đổi nhóm { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Chuyển đổi chú giải công cụ"
  },
  "tools_2fcf772e": {
    "message": "Công Cụ"
  },
  "top_66e0adb6": {
    "message": "Đỉnh"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Bảng bản chép lời khả dụng ở độ rộng trên 720px."
  },
  "tray_839df38a": {
    "message": "Khay"
  },
  "triangle_6072304e": {
    "message": "Tam Giác"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Cửa Xoay (Cong)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "nhấn Control F9 để truy cập tùy chọn hình ảnh. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "nhập Control F9 để truy cập tùy chọn liên kết. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "nhập Control F9 để truy cập tùy chọn bảng. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Không thể xác định url lựa chọn tài nguyên"
  },
  "underline_applied_ae01ec97": {
    "message": "Đã áp dụng gạch chân"
  },
  "underline_removed_3693e17c": {
    "message": "Đã gỡ gạch chân"
  },
  "union_e6b57a53": {
    "message": "Liên Hợp"
  },
  "unpublished_dfd8801": {
    "message": "chưa phát hành"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Bất kỳ thay đổi chưa lưu nào đều sẽ bị mất."
  },
  "untitled_16aa4f2b": {
    "message": "Không có tiêu đề"
  },
  "untitled_efdc2d7d": {
    "message": "không có tiêu đề"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Múi Tên Chéo Lên Và Bên Trái"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Múi Tên Chéo Lên Và Bên Phải"
  },
  "up_c553575d": {
    "message": "Lên"
  },
  "updated_link_a827e441": {
    "message": "Đã cập nhật liên kết"
  },
  "upload_document_253f0478": {
    "message": "Tải Lên Tài Liệu"
  },
  "upload_file_fd2361b8": {
    "message": "Tải Lên Tập Tin"
  },
  "upload_image_6120b609": {
    "message": "Tải Lên Hình Ảnh"
  },
  "upload_media_ce31135a": {
    "message": "Tải Lên Nội Dung Phương Tiện"
  },
  "upload_record_media_e4207d72": {
    "message": "Tải Lên/Ghi Nội Dung Phương Tiện"
  },
  "uploading_19e8a4e7": {
    "message": "Đang Tải Lên"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "danh sách theo thứ tự bảng chữ cái viết hoa"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta Chữ Hoa"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma Chữ Hoa"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda Chữ Hoa"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega Chữ Hoa"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi Chữ Hoa"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi Chữ Hoa"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi Chữ Hoa"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "danh sách theo thứ tự chữ số La Mã viết hoa"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Xichma Chữ Hoa"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta Chữ Hoa"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon Chữ Hoa"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi Chữ Hoa"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Mũi Tên Chỉ Hướng Lên Và Hướng Xuống"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Mũi Tên Chỉ Hướng Lên Và Hướng Xuống (Dày)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Mũi Tên Hướng Lên"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Tam Giác Hướng Lên"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Quyền Sử Dụng:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Quyền Sử Dụng (bắt buộc)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Hãy sử dụng phím mũi tên để điều hướng các tùy chọn."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Hãy sử dụng phím mũi tên để chọn hình dạng."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Hãy sử dụng phím mũi tên để chọn cỡ."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Hãy sử dụng phím mũi tên để chọn vị trí văn bản."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Hãy sử dụng phím mũi tên để chọn cỡ văn bản."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Hãy sử dụng phím mũi tên để chọn cỡ viền."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Được trình đọc màn hình sử dụng để mô tả nội dung của một { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Được trình đọc màn hình sử dụng để mô tả nội dung của hình ảnh"
  },
  "user_documents_c206e61f": {
    "message": "Tài Liệu Người Dùng"
  },
  "user_files_78e21703": {
    "message": "Tập Tin Người Dùng"
  },
  "user_images_b6490852": {
    "message": "Hình Ảnh Người Dùng"
  },
  "user_media_14fbf656": {
    "message": "Nội Dung Phương Tiện Người Dùng"
  },
  "vector_notation_cf6086ab": {
    "message": "Véc-tơ (Ký Hiệu)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Bar Dọc (Ký Hiệu Trình Xây Dựng Tập Hợp)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Dấu Chấm Dọc"
  },
  "video_options_24ef6e5d": {
    "message": "Tùy Chọn Video"
  },
  "video_options_tray_3b9809a5": {
    "message": "Khay Tùy Chọn Video"
  },
  "video_player_b371005": {
    "message": "Trình Phát Video"
  },
  "video_player_for_9e7d373b": {
    "message": "Trình phát video cho "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Trình phát video cho{ title }"
  },
  "video_url_889d3263": {
    "message": "URL Video"
  },
  "view_all_e13bf0a6": {
    "message": "Xem Tất Cả"
  },
  "view_ba339f93": {
    "message": "Xem"
  },
  "view_description_30446afc": {
    "message": "Xem mô tả"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Xem phím tắt"
  },
  "view_title_description_67940918": {
    "message": "Xem mô tả { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Xem số lượng từ và ký tự"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Giới Hạn Người Xem"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Chúng tôi không phát hiện được microphone đang hoạt động được kết nối với thiết bị của bạn."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Chúng tôi không phát hiện được webcam đang hoạt động được kết nối với thiết bị của bạn."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Chúng tôi không phát hiện webcam hoặc microphone đang hoạt động được kết nối với thiết bị của bạn."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam Bị Tắt"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Các trang web chỉ nên có một H1 duy nhất, được sử dụng tự động bởi Tiêu Đề của trang. Đầu đề đầu tiên trong nội dung của bạn phải là H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Khi sử dụng đánh dấu mà định dạng trực quan các mục dưới dạng danh sách nhưng không cho biết mối quan hệ danh sách, người dùng có thể gặp khó khăn trong việc điều hướng thông tin."
  },
  "white_87fa64fd": {
    "message": "Trắng"
  },
  "why_523b3d8c": {
    "message": "Vì Sao"
  },
  "width_492fec76": {
    "message": "Chiều Rộng"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Chiều rộng và chiều cao phải là số"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Trang Chủ Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Số Từ"
  },
  "words_b448b7d5": {
    "message": "Số Từ"
  },
  "wreath_product_200b38ef": {
    "message": "Sản Phẩm Vòng Hoa"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Có"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Bạn đang ở bảng màu. Để điều hướng bảng màu lên, sang trái, xuống hoặc sang phải, hãy sử dụng lần lượt các nút “W”, “A”, “S” và “D”"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Bạn đang ở thanh trượt màu. Để điều hướng thanh trượt sang trái hoặc phải, hãy sử dụng lần lượt các nút “A” và “D”"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Bạn đang ở thanh trượt alpha. Để điều hướng thanh trượt sang trái hoặc phải, hãy sử dụng lần lượt các nút “A” và “D”"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Bạn có các thay đổi chưa lưu trên khay Tạo Biểu Tượng. Bạn có muốn tiếp tục mà không lưu thay đổi?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Bạn có thể cần điều chỉnh các đầu đề bổ sung để duy trì phân cấp trang."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Bạn không được tải lên tập tin trống."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Ảnh của bạn đã được nén cho Icon Maker. Hình ảnh nhỏ hơn { size } KB sẽ không được nén."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Microphone của bạn đang bị chặn trong cài đặt của trình duyệt."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Webcam và microphone của bạn đang bị chặn trong cài đặt của trình duyệt."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Webcam của bạn đang bị chặn trong cài đặt của trình duyệt."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Webcam của bạn có thể đang được sử dụng rồi."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL nhúng YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Phóng to hình ảnh"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Thu nhỏ hình ảnh"
  }
};
formatMessage.addLocale({
  vi: locale
});